import { useEffect } from 'react';

/**
 * Set the browser tab title for a route.
 *
 * The SPA has ONE index.html, so its <title> applies to every route. It used to
 * read "Narratoria ARC Reader Portal", which meant an author signing in — or a
 * plan-buyer arriving from narratoria.com — saw a reader-branded tab on a page
 * that has nothing to do with ARCs. The global default is now the neutral
 * "Narratoria" and routes name themselves with this.
 *
 * Restores the previous title on unmount so a route that sets one cannot leak
 * it into whatever renders next.
 *
 * @param {string} title  e.g. 'Sign in' → "Sign in | Narratoria"
 */
export default function useDocumentTitle(title) {
  useEffect(() => {
    if (!title) return undefined;
    const previous = document.title;
    document.title = `${title} | Narratoria`;
    return () => { document.title = previous; };
  }, [title]);
}
